/* choose one of the two options */

function paymentify(pobj, mode) {
  const fullname = pobj.order.sendername;
  const [firstname, ...othernames] = fullname.split(" ");
  const lastname = othernames.join(" ");

  const email = "noreply.sokodelivery@gmail.com"; //pobj.order.email;
  const username = email;
  const phonenumber = pobj.order.senderphone;
  const currency = "GHS";
  const amount = pobj.amount || 0;
  const orderId = pobj.transactionId;
  const redirectUrl = `${process.env.VUE_APP_FRONTEND_URL}/summary?src=skp`;

  const description = `${fullname}'s SokoDelivery.`;

  if (mode === 1) {
    // SokoPay
    return {
      merchantID: "b83e91a5-b511-44fb-bfcc-be6b6407b582",
      orderID: orderId,
      description,
      amount,
      redirectURL: redirectUrl,
    };
  } else if (mode === 2) {
    // ExpressPay
    return {
      firstname,
      lastname,
      email,
      phonenumber,
      username,
      currency,
      amount,
      "order-id": orderId,
      "order-desc": description,
      "redirect-url": redirectUrl,
      accountnumber: "",
      "order-img-url": "",
      "post-url": "",
    };
  }
}

/* OPTION 1: SokoPay */
// prettier-ignore
const Checkout = function () { var e, t, o, r, n, c; return { configure: function (c) { e = c.merchantID, t = c.orderID, o = c.amount, r = c.redirectURL, n = c.description }, pay: function () { var a = new XMLHttpRequest, i = JSON.stringify({ merchant_id: e, order_id: t, amount: o, redirect_url: r, description: n }); a.open("POST", "https://exchange.sokopay.com/api/v1.0/website_checkout/", !0), a.setRequestHeader("Content-Type", "application/json"), a.send(i), a.onreadystatechange = function () { 4 == a.readyState && 200 == a.status ? (c = JSON.parse(a.responseText), window.location.href = c.payment_redirect_url) : 400 == a.status && console.log(a.responseText) } } } }, SOKOCheckout = Checkout();
// prettier-ignore-end

export default function(data) {
  const checkoutData = paymentify(data, 1);
  SOKOCheckout.configure(checkoutData);
  SOKOCheckout.pay();
}

/* ****** */

/* OPTION 2: ExpressPay */
/*
export default function(data) {
  // console.log(data);
  const checkoutData = paymentify(data, 2);

  fetch(`${process.env.VUE_APP_BACKEND_API_ENDPOINT}/auth/checkout`, {
    method: "POST",
    mode: "cors",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(checkoutData),
  })
    .then((res) => {
      return res.json();
    })
    .then((jsonBody) => {
      // console.log(jsonBody);
      if (jsonBody.status === 1) {
        const checkout = `${process.env.VUE_APP_PAYMENT_API_ENDPOINT}/checkout.php?token=${jsonBody.token}`;
        window.location.replace(checkout);
      }
    })
    .catch((err) => console.error(err));
}
*/
